/* eslint-disable */
import { useState, useEffect } from "react";
import { defineMessages, MessageDescriptor } from "react-intl";

const PREFIX = "ExportNameValidator";
export const nameValidatorMessages = defineMessages({
  isRequired: {
    id: `${PREFIX}.isRequired`,
    defaultMessage: "The field is required",
  },
  mustUsePattern: {
    id: `${PREFIX}.mustMatch`,
    defaultMessage: "The name must contain minimum one of this characters: lowercase or uppercase letters, numbers, and special characters",
  },
});

export const namePatt = /^(?:[A-Za-z0-9!#$%&"();:\s.,<>@'*+\/\[\]\\=?^_`{|}~-]*)(?!.)/;

export function nameValidate(name: string | undefined | null) {
  const errors: MessageDescriptor[] = [];
  if (name !== undefined && name !== null) {
    if (!name.length) {
      errors.push(nameValidatorMessages.isRequired);
    }
    if (!name.match(namePatt)) {
      errors.push(nameValidatorMessages.mustUsePattern);
    }
  }
  return errors;
}

const initState = {
  valid: true,
  errors: [] as MessageDescriptor[],
};

export type UseNameValue = string | undefined | null;
export type UseNameValidatorResult = [boolean, MessageDescriptor[]];
export function useExportNameValidator(name: UseNameValue): UseNameValidatorResult {
  const [state, setState] = useState(initState);
  useEffect(() => {
    const errors = nameValidate(name);
    setState({
      valid: !errors.length,
      errors,
    });
  }, [name]);
  return [state.valid, state.errors];
}
